import { IActivityAction, IActivityContextState } from './activity-interfaces';
import { activityActionTypes } from './activity-action-types';

export const activityReducer = (state: IActivityContextState, action?: IActivityAction): IActivityContextState => {
	switch (action.type) {
		case activityActionTypes.START_CLIENT_LOGS_DATA_LOADING: {
			return {
				...state,
				isClientsLogsDataLoading: true,
			};
		}
		case activityActionTypes.FETCH_CLIENT_LOGS_DATA: {
			return {
				...state,
				isClientsLogsDataLoading: false,
				clientsLogsData: action.payload,
			};
		}
		case activityActionTypes.FETCH_FAIL: {
			return {
				...state,
				isClientsLogsDataLoading: false,
			};
		}
		default: {
			return state;
		}
	}
};
